import React, { useEffect, useMemo, useState } from 'react';
import { Select } from 'antd';
import HStack from './Layout/HStack';

// config item shape:
// {
//   key: string,
//   show: boolean,
//   defaultValue: any,
//   options: Option[] | (baseList: T[]) => Option[],  — function receives list pre-filtered by all OTHER active filters
//   filterFunc: (item: T, value: any) => boolean,
//   style?: CSSProperties,
// }

const FiltersHandler = ({ list, config, onFiltered }) => {
    const [filterValues, setFilterValues] = useState(() =>
        Object.fromEntries(config.map(cfg => [cfg.key, cfg.defaultValue]))
    );

    const resolvedOptions = useMemo(() =>
        Object.fromEntries(config.map(cfg => {
            if (typeof cfg.options === 'function') {
                const otherConfigs = config.filter(c => c.key !== cfg.key);
                const baseList = list.filter(item =>
                    otherConfigs.every(c => c.filterFunc(item, filterValues[c.key]))
                );
                return [cfg.key, cfg.options(baseList)];
            }
            return [cfg.key, cfg.options];
        })),
    [list, config, filterValues]);

    const filteredList = useMemo(() =>
        list.filter(item => config.every(cfg => cfg.filterFunc(item, filterValues[cfg.key]))),
    [list, config, filterValues]);

    useEffect(() => {
        onFiltered(filteredList, filterValues);
    }, [filteredList]);

    const onFilterChange = (key, value) => {
        setFilterValues(prev => ({ ...prev, [key]: value }));
    };

    return (
        <HStack space={'0.75rem'} flexWrap={'wrap'}>
            {config.filter(cfg => cfg.show).map(cfg => (
                <Select
                    key={cfg.key}
                    options={resolvedOptions[cfg.key]}
                    value={filterValues[cfg.key]}
                    onChange={(val) => onFilterChange(cfg.key, val)}
                    style={cfg.style}
                />
            ))}
        </HStack>
    );
};

export default FiltersHandler;
